import React from "react";
import { Typography, Container, Box } from "@mui/material";

const WhoAmI = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#000000",
        color: "#ffffff",
        py: { xs: 5, md: 7 },
        mb: 0,
      }}
    >
      <Container
        maxWidth="md"
        sx={{ textAlign: "center", px: { xs: 3, sm: 4, md: 6 } }}
      >
        <Typography
          variant="h4"
          component="h3"
          sx={{
            fontStyle: "italic",
            mb: { xs: 2.5, md: 3.5 },
            fontSize: "clamp(1.9rem, 3.2vw, 2.4rem)",
          }}
        >
          Who am I?
        </Typography>

        <Typography
          variant="h5"
          component="h2"
          sx={{
            mb: { xs: 1.5, md: 2 },
            fontSize: "clamp(1.4rem, 2.8vw, 1.8rem)",
            fontWeight: 600,
          }}
        >
          Professor Louise Serpell
        </Typography>

        <Typography
          variant="h6"
          component="h2"
          sx={{
            mb: 1,
            fontSize: "clamp(1.1rem, 2.5vw, 1.3rem)",
            lineHeight: 1.6,
          }}
        >
          30 years research in Biochemistry and Neuroscience
        </Typography>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            mb: 1,
            fontSize: "clamp(1.1rem, 2.5vw, 1.3rem)",
            lineHeight: 1.6,
          }}
        >
          <Box component="span" sx={{ fontWeight: 700 }}>
            Expert
          </Box>{" "}
          in proteins, protein misfolding in disease
        </Typography>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            mb: 1,
            fontSize: "clamp(1.1rem, 2.5vw, 1.3rem)",
            lineHeight: 1.6,
          }}
        >
          Neurodegenerative disease and translational directions
        </Typography>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontSize: "clamp(1.1rem, 2.5vw, 1.3rem)",
            lineHeight: 1.6,
          }}
        >
          <Box component="span" sx={{ fontWeight: 700 }}>
            Areas of specialist interest:
          </Box>{" "}
          Alzheimer&apos;s disease causation; pathology and translational
          directions
        </Typography>
      </Container>
    </Box>
  );
};

export default WhoAmI;
